<template>
  <div @submit.prevent="submitForm">
    <div class="rd-header rd-header--crushing">
      <h1 class="rd-h1">Krossning</h1>
    </div>

    <div v-if="crushingRecord" class="rd-container">
      <div class="rd-block rd-block--form">
          <h2 class="rd-block__header">Information</h2>

          <div class="rd-input-container" :class="{ 'has-error': errors.has('recordHeading') }">
            <label for="recordHeading">Rubrik</label>

            <b-form-input
              id="recordHeading"
              name="recordHeading"
              v-model="crushingRecord.recordHeading"
              :disabled="!editMode"
              placeholder="Rubrik"
              v-validate="'required|no_surrounding_space'" :class="{ 'validation-failed': errors.first('recordHeading') }" />
            <span v-if="errors.has('recordHeading')" class="validation-failed"> {{ errors.first('recordHeading') }} </span>
          </div>

        <div class="rd-input-container" v-if="crushingRecord.recordKey">
          <label for="recordHeadingId">Krossnings Id</label>

          <b-form-input
            id="recordHeadingId"
            name="recordHeadingId"
            v-model="crushingRecord.recordKey"
            :disabled="true" />
        </div>
      </div>

      <div class="rd-block">
        <h2 class="rd-block__header">Substans</h2>

        <div class="rd-block__form">
          <div class="rd-input-container">
            <label for="">Sök substans</label>

            <b-form-input v-model="substanceQuery" @input="getSubstancesDebounced()" @focus="searchElementFocus()" />
          </div>

          <div v-click-outside="clickOutside" v-if="showSubstanceDropdown && substanceResults.length > 0" class="substance-search-result">
            <ul>
              <li
                v-for="result of substanceResults"
                :key="result.substanceId"
                class="substance-search-result__item">
                <button :class="'substance-search-result__action'" @click="addSubstance(result)">
                  {{capitalize(result.substanceNameSv)}}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <b-table class="rd-block__table" :items="crushingRecord.substances" :fields="substanceTableSettings" responsive>
          <template #cell(actions)="row">
            <!-- <button  @click="deleteSubstance(row.item.silSubstanceId)" class="rd-button rd-button--small rd-button--3">
              Ta bort
            </button> -->

            <mu-raised-button
              class="rd-button rd-button--small rd-button--icon-button"
              icon="delete"
              primary
              @click="deleteSubstance(row.item.substanceId)" />
          </template>
        </b-table>
      </div>

      <div class="rd-block">
        <h2 class="rd-block__header">Läkemedelsform</h2>

        <div class="rd-input-container">
          <label for="primaryForm">Primär form</label>
          <b-form-select
            id="primaryForm"
            name="primaryForm"
            v-model="crushingRecord.primaryDrugFormCode"
            value-field="drugFormCode"
            text-field="drugFormTextSv"
            :options="drugFormsOptions" />
        </div>

        <div class="rd-input-container">
          <label for="secondaryForm">Sekundär form</label>
          <b-form-select
            id="secondaryForm"
            name="secondaryForm"
            v-model="secondaryDrugForm"
            value-field="drugFormCode"
            text-field="drugFormTextSv"
            :options="drugFormsOptions" />
          </div>
      </div>

      <div class="rd-block">
        <!-- <b-button :disabled="!canFetchDrugs" @click="getDrugs()" class="mr-1">
          Hämta läkemedel
        </b-button> -->

        <h2 class="rd-block__header">Läkemedel</h2>

        <mu-raised-button class="rd-button rd-button--small" label="Hämta läkemedel" icon="download" primary :disabled="!canFetchDrugs" @click="getDrugs()" />

        <b-table :items="crushingRecord.drugList" :fields="drugListTableSettings" responsive>
          <template #cell(applicable)="row">
            <b-form-select
              v-model="row.item.isApplicable"
              :id="`applicable_${row.item.nplId}`"
              :options="applicableOptions"
              @change="checkExample(row.item)" />
          </template>
          <template #cell(isExample)="row">
            <b-form-checkbox
              v-model="row.item.isExample" 
              :id="`isExample_${row.item.nplId}`"
              :disabled="row.item.isApplicable !== 'yes'" />
          </template>
          <template #cell(isMarketed)="row">
            <b-form-checkbox
              class="disabledbox"
              v-model="row.item.isMarketed"
              :id="`isMarketed_${row.item.nplId}`" />
          </template>
        </b-table>
      </div>

      <ul class="rd-items-list rd-island-container">
        <li>
          <h3>Rekommendation för oral administrering vid sväljsvårigheter</h3>

          <editor
            :areaKey="'pa'"
            v-model="crushingRecord.recommendations.keyPeroral"
            :editable="editMode"
            emptyLabel="[Rekommendation för oral administrering vid sväljsvårigheter]"></editor>
        </li>

        <li>
          <h3>Rekommendation för administrering i enteral sond</h3>
      
          <editor
            :areaKey="'es'"
            v-model="crushingRecord.recommendations.keyEnteral"
            :editable="editMode"
            emptyLabel="[Rekommendation för administrering i enteral sond]"></editor>
        </li>

        <li>
          <h3>Alternativ administreringsväg eller alternativt läkemedel</h3>

          <editor
            :areaKey="'alt'"
            v-model="crushingRecord.recommendations.keyAlternative"
            :editable="editMode"
            emptyLabel="[Alternativ administreringsväg]"></editor>
        </li>
      </ul>
      
      <b-row v-if="crushingRecord.recordChangeDate">
        <b-col>
          <modified-date :date="crushingRecord.recordChangeDate" />
        </b-col>
      </b-row>
        
      <div class="rd-actions-row" v-if="editMode">
        <b-form-checkbox
          id="publish"
          v-model="crushingRecord.isPublished"
          name="publish"
          class="rd-actions-row__checkbox">
          Publicera
        </b-form-checkbox>

        <mu-raised-button
          :class="['rd-button', { 'rd-button--green': crushingRecord.isPublished }]"
          label="Spara"
          icon="upload"
          primary
          @click="submitForm()" />

        <mu-raised-button
          class="rd-button rd-button--destructive"
          label="Ta bort"
          icon="remove"
          primary
          v-if="crushingRecord.recordKey"
          @click="openConfirmDialog" />

        <mu-raised-button
          class="rd-button"
          :disabled="isNew || isDirty"
          label="Sil export format"
          icon="search"
          primary 
          @click="gotoFormatDisplay()"/>

        <div v-show="saveSuccess" class="rd-save-success" >Sparat</div>
      </div>
      <div v-show="errorMessage" class="rd-island-container rd-island-container--warning">
        {{ errorMessage }}
      </div>
    </div>

    <mu-dialog :open="confirmDialog" title="Bekräfta" @close="closeConfirmDialog" dialog-class="rd-dialog">
      Är du säker på att du vill fortsätta?

      <mu-flat-button slot="actions" primary @click="closeConfirmDialog" label="Avbryt" />
      <!-- <mu-flat-button slot="actions" primary label="Ja" /> -->
      <mu-raised-button
        slot="actions"
        v-if="crushingRecord.recordKey"
        class="rd-button rd-button--destructive rd-button--small"
        label="Ta bort"
        primary
        @click="deleteRecord" />
    </mu-dialog>
  </div>
</template>

<script>
import { getCrushingDrugForms } from '../store/actions'
import { computed, onMounted, reactive, toRefs, watch } from '@vue/composition-api'
import { find, filter, debounce, capitalize, get, map, cloneDeep, isEqual } from 'lodash'
import router from '../router'
import axios from 'axios'

const emptyCrushingRecordItem = {
  recordKey: '',
  recordHeading: '',
  isPublished: false,
  recordChangeDate: '', // BE ignores but needs field
  recordCreateDate: '', // BE ignores but needs field
  substances: [],
  primaryDrugFormCode: null,
  secondaryDrugFormCodeList: [],
  drugList: [],
  recommendations: {
    keyPeroral: '',
    keyEnteral: '',
    keyAlternative: ''
  }
}

export default {
  name: 'EditCrushingRecord',
  props: ['id'],
  computed: {
    user () {
      return this.$store.state.user
    },
    drugForms () {
      return this.$store.getters.crushingDrugForms || []
    },
    drugFormsOptions () {
      return [{drugFormCode: null, drugFormTextSv: 'Ej vald'}, ...this.drugForms]
    }
  },
  mounted () {
    if (this.drugForms.length === 0) {
      getCrushingDrugForms(this.$store)
    }
  },
  methods: {
    getDrugFormText (silCode) {
      const drugForm = find(this.drugForms, form => form.drugFormCode === silCode)
      return drugForm ? drugForm.drugFormTextSv : `code: ${silCode}`
    },
    submitForm () {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.createOrUpdateCrushingRecord()
        } else {
          const el = this.$el.querySelector('.has-error input')
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      })
    }
  },
  setup (props) {
    const state = reactive({
      recordId: props.id,
      pristineRecord: cloneDeep(emptyCrushingRecordItem),
      crushingRecord: cloneDeep(emptyCrushingRecordItem),
      generalRecommendation: null,
      confirmDialog: false,
      editMode: true,
      substanceQuery: '',
      substanceResults: [],
      searchFocus: false,
      triggerDropdown: false,
      errorMessage: '',
      saveSuccess: false
    })

    const secondaryDrugForm = computed({
      get () {
        const list = get(state, 'crushingRecord.secondaryDrugFormCodeList')
        return Array.isArray(list) && list.length ? list[0] : null
      },
      set (value) {
        state.crushingRecord.secondaryDrugFormCodeList = [value]
      }
    })
    const showSubstanceDropdown = computed(() => state.triggerDropdown)
    const isDirty = computed(() => !isEqual(state.pristineRecord, state.crushingRecord))
    const isNew = computed(() => state.recordId === 'ny')
    const canFetchDrugs = computed(() => state.crushingRecord.substances.length > 0 && state.crushingRecord.primaryDrugFormCode)

    onMounted(() => {
      window.scrollTo(0, 0)
      getRecord()
    })

    function gotoFormatDisplay () {
      if (!isDirty.value) {
        router.push({name: 'KrossningsSilFormat', params: {id: state.crushingRecord.recordKey}})
      }
    }

    function getRecord () {
      if (state.recordId === 'ny') {
        state.pristineRecord = cloneDeep(emptyCrushingRecordItem)
        state.crushingRecord = cloneDeep(state.pristineRecord)
      } else {
        axios.get('crushingapi/getCrushingRecord', {params: {recordKey: state.recordId}})
        .then((result) => {
          if (result.data) {
            state.pristineRecord = result.data
            state.crushingRecord = cloneDeep(state.pristineRecord)
          }
        })
        .catch((error) => {
          console.log(error)
        })
      }
    }

    function deleteRecord () {
      axios.get('crushingapi/deleteCrushingRecord', {params: {recordKey: state.recordId}})
        .then(() => {
          router.push('/krossning')
        })
        .catch((error) => {
          console.log(error)
        })
    }

    const getSubstancesDebounced = debounce(function () {
      state.triggerDropdown = true
      const params = {searchValue: state.substanceQuery}
      if (props.id !== 'ny') {
        params.recordKey = state.crushingRecord.recordKey
      }
      axios.get('crushingapi/getCrushingSelectableSubstances', { params })
        .then((result) => {
          if (result.data) {
            state.substanceResults = filter(result.data, substance => !find(state.crushingRecord.substances, sub => {
              return sub.substanceId === substance.substanceId
            }))
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }, 300)

    function getDrugs () {
      axios.post('crushingapi/getCrushingSelectableDrugs', {
        listSubstanceId: map(state.crushingRecord.substances, substance => substance.substanceId),
        primaryDrugForm: state.crushingRecord.primaryDrugFormCode,
        listSecondaryDrugForm: state.crushingRecord.secondaryDrugFormCodeList,
        recordKey: state.crushingRecord.recordKey
      })
      .then((result) => {
        if (result.data) {
          state.crushingRecord.drugList = result.data
        }
      })
      .catch((error) => {
        console.log(error)
      })
    }

    function searchElementFocus () {
      state.searchFocus = true
      state.triggerDropdown = true
    }
    function clickOutside () {
      state.searchFocus = false
      state.triggerDropdown = false
    }

    function checkExample (drug) {
      if (drug.isApplicable !== 'yes') {
        drug.isExample = false
      }
    }

    function openConfirmDialog () {
      this.confirmDialog = true
    }
    function closeConfirmDialog () {
      this.confirmDialog = false
    }

    function togglePublish () {
      state.crushingRecord.isPublished = !state.crushingRecord.isPublished
    }

    function deleteSubstance (silId) {
      state.crushingRecord.substances = state.crushingRecord.substances.filter(substance => substance.substanceId !== silId)
      state.crushingRecord.drugList = []
    }

    function addSubstance (substance) {
      state.crushingRecord.substances.push(substance)
      state.triggerDropdown = false
      state.crushingRecord.drugList = []
    }

    function showSaveSuccess () {
      state.saveSuccess = true
      setTimeout(() => {
        state.saveSuccess = false
      }, 10000)
    }

    function createOrUpdateCrushingRecord () {
      const type = state.crushingRecord.recordKey ? 'updateCrushingRecord' : 'createCrushingRecord'
      if (!state.crushingRecord.recordHeading || state.crushingRecord.substances.length === 0 || !state.crushingRecord.primaryDrugFormCode) {
        state.errorMessage = 'Rubrik, primär form och minst en substans måste finnas för att spara'
        return
      } else {
        state.errorMessage = ''
      }
      axios.post('crushingapi/' + type, state.crushingRecord)
      .then((result) => {
        if (result.data.resultCode === 'Ok') {
          if (type === 'createCrushingRecord') {
            state.crushingRecord.recordKey = result.data.recordKey
            window.history.replaceState(null, null, `id=${result.data.recordKey}`)
            state.recordId = result.data.recordKey
          }
          getRecord()
          showSaveSuccess()
        } else {
          state.errorMessage = result.data.message
        }
      })
      .catch((error) => {
        console.log(error)
      })
    }

    watch(() => state.crushingRecord.primaryDrugFormCode, (newVal, oldVal) => {
      if (oldVal && newVal !== oldVal) {
        state.crushingRecord.drugList = []
      }
    })

    const substanceSortable = computed(() => state.crushingRecord.substances && state.crushingRecord.substances.length > 1)
    const substanceTableSettings = computed(() => [
      {
        label: 'Substans',
        key: 'substanceNameSv',
        sortable: substanceSortable.value
      },
      {
        label: 'Substans-Id',
        key: 'substanceId',
        sortable: substanceSortable.value
      },
      {
        label: 'Uppdateringsdatum',
        key: 'changeDate',
        sortable: substanceSortable.value
      },
      { key: 'actions', label: '' }
    ])

    const applicableOptions = [
      {text: 'Ej bedömt', value: 'notHandled'},
      {text: 'Ja', value: 'yes'},
      {text: 'Nej', value: 'no'}
    ]

    const drugListTableSettings = [
      {
        label: 'Applicerbart',
        key: 'applicable',
        sortable: true
      },
      {
        label: 'Exempel',
        key: 'isExample',
        sortable: true
      },
      {
        label: 'Npl Id',
        key: 'nplId',
        sortable: true
      },
      {
        label: 'Läkemedel',
        key: 'silDrugName',
        sortable: true
      },
      {
        label: 'Beredningsform',
        key: 'silDrugFormTextSv'
      },
      {
        label: 'Marknadsförs',
        key: 'isMarketed'
      },
      {
        label: 'Uppdateringsdatum',
        key: 'changeDate',
        sortable: true
      }
    ]

    return {
      ...toRefs(state),
      togglePublish,
      openConfirmDialog,
      closeConfirmDialog,
      deleteRecord,
      deleteSubstance,
      substanceTableSettings,
      drugListTableSettings,
      applicableOptions,
      getSubstancesDebounced,
      addSubstance,
      capitalize,
      clickOutside,
      searchElementFocus,
      showSubstanceDropdown,
      createOrUpdateCrushingRecord,
      secondaryDrugForm,
      getDrugs,
      canFetchDrugs,
      checkExample,
      isDirty,
      isNew,
      gotoFormatDisplay
    }
  }
}
</script>
<style>
  .disabledbox {
    pointer-events: none;
  }
</style>